import type {ReactNode} from "react";
import React from "react";
import {FormattedMessage} from "react-intl";

export default (regExp: RegExp, message: ReactNode = <FormattedMessage id="form.validations.regex" />) => {
    return (value: any) => {
        if(typeof value !== "string" || value === '') {
            return undefined;
        }

        if(!regExp.exec(value)) {
            return message;
        }

        return undefined;
    };
}